import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  orders: { id: number; order: number }[];
}

export const useUpdateEntityTypeOrder = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) =>
    axios.post(`${env.verifyServiceUrl}individual/entity_type/order/`, params, {
      headers: { Authorization: authHeader },
    })
  );
};
